import { Provider } from '@angular/core';

/**
 * No-op stand-in for `demo.providers.ts`, used by all NON-demo builds via
 * `fileReplacements` in angular.json. It imports none of the demo code, so the demo
 * classes, forged data graph and asset references are fully tree-shaken out of
 * production/dev/beta bundles (the web analogue of iOS's `#if DEMO_SUPPORT` exclusion).
 *
 * The real implementation in `demo.providers.ts` is only compiled by the `demo`
 * build configuration.
 */
export function demoProviders(): Provider[] {
  return [];
}
